import React from 'react';
import { useConnect } from '@lore/query-connect';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import IconSection from '../../_new_card_components/IconSection';

export default function School(props) {
  const { event } = props;

  const site = useConnect('site.byId', {
    id: event.data.siteId
  }, {
    enabled: !!event.data.siteId
  });

  if (!event.data.siteId) {
    return null;
  }

  return (
    <IconSection
      icon={BuildingOfficeIcon}
      title={site.data.name}
    />
  );
}
